import { Component } from '@angular/core';

@Component({
  selector: 'mtm-undo-icon',
  templateUrl: './undo-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class UndoIconComponent {}
